'use client';

import { c as _c } from "react/compiler-runtime";
import compass from '@images/renders/visual_images/rose.svg';
import { URLS } from '@lib/tools/helpers/constants';
import axios from 'axios';
import cn from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import Svg from 'react-inlinesvg';
import style from './Compass.module.scss';
const Compass = t0 => {
  const $ = _c(31);
  const {
    someStyles,
    bulk,
    genPlanMob,
    genPlan
  } = t0;
  const roseRef = useRef(null);
  const cdnLink = `${URLS.CDN_PLANS}/${bulk}/genplan/mini-genplan-moments-site.svg`;
  const [isValid, setIsValid] = useState(false);
  const [link, setLink] = useState(null);
  const [check, setCheck] = useState(false);
  const checkLinkValidity = _temp3;
  let t1;
  let t2;
  if ($[0] !== cdnLink) {
    t1 = () => {
      const checkCdnValidity = async () => {
        const isValid_0 = await checkLinkValidity(cdnLink);
        setIsValid(isValid_0);
        setCheck(true);
      };
      checkCdnValidity();
    };
    t2 = [cdnLink];
    $[0] = cdnLink;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== bulk) {
    t3 = () => {
      const rose = document.querySelector("#compass");
      if (!rose) {
        return;
      }
      const k1 = document.querySelector("#k_1");
      const k21 = document.querySelector("#k2_1");
      if (Number(bulk) === 9335) {
        k1.classList.add(style.active);
      }
      if (Number(bulk) === 9758) {
        k21.classList.add(style.active);
      }
    };
    $[3] = bulk;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const beforeSvgInjection = t3;
  let t4;
  let t5;
  if ($[5] !== beforeSvgInjection || $[6] !== bulk || $[7] !== isValid) {
    t4 = () => {
      if (roseRef && bulk && isValid) {
        beforeSvgInjection();
      }
    };
    t5 = [roseRef, bulk, isValid, beforeSvgInjection];
    $[5] = beforeSvgInjection;
    $[6] = bulk;
    $[7] = isValid;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== cdnLink || $[11] !== check || $[12] !== isValid) {
    t6 = () => {
      if (isValid) {
        setLink(cdnLink);
      }
      if (check && !isValid) {
        setLink(compass);
      }
    };
    $[10] = cdnLink;
    $[11] = check;
    $[12] = isValid;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== check || $[15] !== isValid) {
    t7 = [isValid, check];
    $[14] = check;
    $[15] = isValid;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  useEffect(t6, t7);
  const t8 = genPlan && genPlanMob ? style.compassGenplanMob : "";
  let t9;
  if ($[17] !== someStyles || $[18] !== t8) {
    t9 = cn(someStyles, t8);
    $[17] = someStyles;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== beforeSvgInjection || $[21] !== isValid || $[22] !== link?.src) {
    t10 = !isValid && <Svg className={style.compass} id="compass" src={link?.src} alt={"\u0420\u043E\u0437\u0430_\u0432\u0435\u0442\u0440\u043E\u0432"} onLoad={() => beforeSvgInjection()} />;
    $[20] = beforeSvgInjection;
    $[21] = isValid;
    $[22] = link?.src;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isValid || $[25] !== link) {
    t11 = isValid && <Svg className={style.compass} id="compass" src={link} alt={"\u0420\u043E\u0437\u0430_\u0432\u0435\u0442\u0440\u043E\u0432"} />;
    $[24] = isValid;
    $[25] = link;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = <><div className={t9} ref={roseRef}>{t10}{t11}</div></>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default Compass;
function _temp(response) {
  return response.status === 200;
}
function _temp2(error) {
  console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435 \u0441\u0441\u044B\u043B\u043A\u0438:", error);
  return false;
}
function _temp3(url) {
  return axios.head(url).then(_temp).catch(_temp2);
}